/**
 * HTTP Client Error Classes
 */

export class FetchError extends Error {
  /** Optional structured metadata from the error response body (e.g. { quoteStatus }) */
  meta?: Record<string, unknown>;

  constructor(
    message: string,
    public status?: number,
    public statusText?: string,
    public url?: string,
    public method?: string,
  ) {
    super(message);
    this.name = "FetchError";
  }

  toString(): string {
    return `${this.name}: ${this.message} [${this.method} ${this.url}] - ${this.status} ${this.statusText}`;
  }
}
